import React from 'react';
import { Text } from '@etg/wings';

interface TextWithButtonProps {
  button: React.ReactNode;
  className?: string;
  content: string;
}

const TextWithButton = ({ button, className, content }: TextWithButtonProps) => {
  const regex = new RegExp(/(\{BUTTON})/g);
  const textArray = content?.split(regex);

  return (
    <Text as="p" asHtml className={className}>
      {textArray?.map((text, index) => {
        if (regex.test(text)) {
          return <span key={`text-with-button-${index}`}>{button}</span>;
        }

        return <span key={`text-with-button-${index}`}>{text}</span>;
      })}
    </Text>
  );
};

export default TextWithButton;
